import PropTypes from 'prop-types';
import BidPresenter from 'presenters/BidPresenter';
import Presenter from 'utils/PropTypesPresenter';
import MessagePresenter from './MessagePresenter';

export default new Presenter(
  {
    uid: PropTypes.string,
    unreadCount: PropTypes.number,
    bidsCount: PropTypes.number,
    createdAt: PropTypes.number,
    latestMessage: MessagePresenter.shape(),
    latestBid: BidPresenter.shape(),
    loanOfficerId: PropTypes.number,
    buyerId: PropTypes.number,
    isHidden: PropTypes.bool,
    isFavorite: PropTypes.bool,
    conversationDays: PropTypes.shape(),
  },
  {},
);



// WEBPACK FOOTER //
// ./src/presenters/FirebaseChatPresenter.js